/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const massa_chain_about = () => `Massa is the first and only layer 1 blockchain that tackles the trilemma of scalability, decentralization, and security without compromise. Achieving high transactions per second with thousands of nodes, our parallel block architecture and unique Autonomous Smart Contracts (ASCs) are setting new standards in DeFi and web3.`
